<kl-grid
  [columns]="[
    { header: 'fullname' | translate, binding: 'full_name', visible: true },
    {
      header: 'username' | translate,
      binding: 'username',
      size: '*',
      visible: true
    },
    { header: 'email' | translate, binding: 'email', size: '*', visible: true }
  ]"
  [filterable]="false"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [filterSelectItems]="filterSelectItems"
  [service]="{
    service: 'user',
    name: 'users',
    form: 'USER',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MANAGEMENT'"
  [moduleName]="'USER_LIST'"
  [gridName]="'grdUserList'"
>
</kl-grid>
<div
  class="modal fade"
  bsModal
  #userPasswordModal="bs-modal"
  [config]="{ backdrop: false }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
  style="top: 100px"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-shipment" class="modal-title pull-left">
          {{ "create_password" | translate }}
        </h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="userPasswordModal.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <kl-alert
          [type]="'error'"
          [message]="userPasswordInputAlertMessage"
          [show]="userPasswordInputWarning || userPasswordApiWarning"
          (onClose)="
            userPasswordInputWarning = false; userPasswordApiWarning = false
          "
        ></kl-alert>
        <form #userPasswordForm="ngForm" novalidate>
          <div class="col-md-12 mt-3">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="form-group row">
                  <label for="password" class="col-md-4 col-sm-12">
                    <small
                      >{{ "password" | translate }}
                      <i class="text-danger">*</i></small
                    >
                  </label>
                  <div class="col-md-8 col-sm-12">
                    <input
                      type="password"
                      id="password"
                      name="password"
                      class="form-control form-control-sm"
                      required
                      maxlength="50"
                      #password="ngModel"
                      [disabled]="createPasswordSpinner"
                      (ngModelChange)="userPasswordInputWarning = false"
                      [ngClass]="
                        userPasswordInputWarning && password.invalid
                          ? 'errorInput'
                          : ''
                      "
                      [(ngModel)]="userPasswordDetail.password"
                    />
                    <div
                      *ngIf="userPasswordInputWarning && password.invalid"
                      class="errorMessage"
                    >
                      {{ "important_area" | translate }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="password_confirmation" class="col-md-4 col-sm-12">
                    <small
                      >{{ "password_confirmation" | translate }}
                      <i class="text-danger">*</i></small
                    >
                  </label>
                  <div class="col-md-8 col-sm-12">
                    <input
                      type="password"
                      id="password_confirmation"
                      name="password_confirmation"
                      class="form-control form-control-sm"
                      required
                      maxlength="50"
                      #password_confirmation="ngModel"
                      [disabled]="createPasswordSpinner"
                      (ngModelChange)="userPasswordInputWarning = false"
                      [ngClass]="
                        userPasswordInputWarning &&
                        password_confirmation.invalid
                          ? 'errorInput'
                          : ''
                      "
                      [(ngModel)]="userPasswordDetail.password_confirmation"
                    />
                    <div
                      *ngIf="
                        userPasswordInputWarning &&
                        password_confirmation.invalid
                      "
                      class="errorMessage"
                    >
                      {{ "important_area" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success btn-sm"
          data-dismiss="modal"
          (click)="createPassword()"
        >
          <i
            class="fal fa-spinner fa-spin fa-fw"
            *ngIf="createPasswordSpinner"
            style="font-size: 21px"
          ></i>
          {{ "create" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm"
          data-dismiss="modal"
          (click)="userPasswordModal.hide()"
        >
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
